import { useMsal } from "@azure/msal-react";
import { useCallback, useEffect, useState } from "react";

// Must match auth-config.ts storage logic exactly
// localStorage = session partagée entre onglets (prod uniquement)
// sessionStorage = session isolée par onglet (recette + localhost)
const isProd = process.env.REACT_APP_ENVIRONMENT === "production";
const useSharedSession = isProd;
const storage = useSharedSession ? localStorage : sessionStorage;

export const useRefreshTokenExpiry = () => {
	const { instance } = useMsal();
	const [tokenTimeout, setTokenTimeout] = useState<number>(10000); // Default 10 seconds

	const getTokenExpiryTimeout = useCallback((): number => {
		const account = instance.getActiveAccount();

		if (!account) {
			throw new Error("No active account");
		}

		const msalKeys = [];

		for (let i = 0; i < storage.length; i++) {
			const key = storage.key(i);
			if (key?.includes(account.homeAccountId)) {
				msalKeys.push(key);
			}
		}

		const refreshTokenKey = msalKeys.find(key =>
			key.toLowerCase().includes("refreshtoken")
		);

		if (!refreshTokenKey) {
			throw new Error("No refresh token found");
		}

		const tokenData = storage.getItem(refreshTokenKey);

		if (!tokenData) {
			throw new Error("No token data found");
		}

		const parsedToken = JSON.parse(tokenData);

		if (!parsedToken.expiresOn) {
			throw new Error("No expiry information found");
		}

		return parseInt(parsedToken.expiresOn) * 1000 - Date.now();
	}, [instance]);

	useEffect(() => {
		setTokenTimeout(getTokenExpiryTimeout());
	}, []);

	return {
		tokenTimeout
	};
};
